import { SET_PRINT_RECEIPT_ORDER_ID, SET_PRINT_RECEIPT_PRINT_SETTINGS } from '../../actionTypes/printReceipt'

export const setPrintReceiptOrderId = value => ({ type: SET_PRINT_RECEIPT_ORDER_ID, value })
export const setPrintReceiptPrintSettings = value => ({ type: SET_PRINT_RECEIPT_PRINT_SETTINGS, value })

